/**
 * Download a file without exposing the URL in browser
 * Uses fetch + blob to trigger direct download
 */
export const downloadFile = async (url, filename = 'download') => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Download failed');
    }
    
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the blob URL
    window.URL.revokeObjectURL(blobUrl);
    
    return true;
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

/**
 * Download multiple files as a zip without exposing the URL
 */
export const downloadZip = async (url, filename = 'files.zip') => {
  return downloadFile(url, filename);
};
